export default {
  setItem (key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      return {}
    }
  },
  getItem (key) {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch (err) {
      return {}
    }
  },
  removeItem (key) {
    localStorage.removeItem(key)
  },
  clearItem () {
    localStorage.clear()
  },
  setSession (key, value) {
    sessionStorage.setItem(key, value)
  },
  getSession (key) {
    return sessionStorage.getItem(key)
  },
  removeSession (key) {
    sessionStorage.removeItem(key)
  },
  clearSession () {
    sessionStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/store/storage.js